import { sanitizeTextInput } from './benefitsProvider'
import { PAYERS_FALLBACK_LIST } from './constants'

export const benefitsServices = {
  VERIFYTX: 'verifyTx',
  AAC: 'aac',
  AmericanAddictionCenters: 'american addiction centers',
  STORYBOOK: 'storybook'
}

const VERIFYTX_PUBLIC_DEMO_KEY = '1PhH0DcP7uQ6lL94Eo5hkqZe4aZhS88iGWBK4MFg'

const sortPayersByName = (payers) =>
  payers.sort((a, b) => a.payerName.localeCompare(b.payerName))

export const getPayers = async (benefitsKey) => {
  const insurerBenefitsKey = benefitsKey || VERIFYTX_PUBLIC_DEMO_KEY

  try {
    const response = await fetch(
      `https://api.verifytx.com/webforms/widgets/${insurerBenefitsKey}`,
      {
        method: 'GET',
        headers: {
          Accept: '*/*'
        }
      }
    )

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const payerList = await response.json()
    const payersResponse = payerList.message?.payers || PAYERS_FALLBACK_LIST

    return sortPayersByName(payersResponse)
  } catch (error) {
    console.error('Error fetching payers:', error)
    return sortPayersByName(PAYERS_FALLBACK_LIST)
  }
}

export const filterPayers = (searchTerm, payerList = []) => {
  const payersList = payerList.length ? payerList : PAYERS_FALLBACK_LIST
  let res = payersList.filter((payer) => {
    let searchRegex = new RegExp(
      `(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
      'i'
    )
    return payer.payerName.toLowerCase().match(searchRegex)
  })
  return res
}

export const submitFormData = async ({
  form,
  benefitsKey,
  benefitsProvider
}) => {
  try {
    const sanitizedForm = Object.keys(form).reduce((acc, key) => {
      if (form[key]) {
        acc[key] = sanitizeTextInput(form[key])
      }
      return acc
    }, {})

    return await handleBenefitsProvider({
      form: sanitizedForm,
      benefitsKey,
      benefitsProvider
    })
  } catch (error) {
    console.log('Error submitting benefits verification', error)
    return false
  }
}

export const handleBenefitsProvider = async ({
  form,
  benefitsKey,
  benefitsProvider
}) => {
  if (!benefitsProvider) {
    return
  }
  if (benefitsProvider.toLowerCase() === benefitsServices.VERIFYTX) {
    return submitBenefitsToVerifyTx({
      form,
      benefitsKey,
      benefitsProvider
    })
  }
  if (
    benefitsProvider.toLowerCase() === benefitsServices.AAC ||
    benefitsProvider.toLowerCase() === benefitsServices.AmericanAddictionCenters
  ) {
    return submitBenefitstoAAC({ form, benefitsProvider })
  }
  return submitBenefitsToVerifyTx({
    form,
    benefitsKey,
    benefitsProvider
  })
}

const getPageURL = () => {
  return window?.location?.href || ''
}

export const submitBenefitsToVerifyTx = async ({ form, benefitsKey }) => {
  if (!form || !benefitsKey) {
    return false
  }
  const response = await fetch(`https://api.verifytx.com/webforms/verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-webform-key': benefitsKey,
      accept: '*/*'
    },
    body: JSON.stringify({
      ...form
    })
  })

  if (response && response.ok) {
    return true
  }
  return false
}

export const submitBenefitstoAAC = async ({ form }) => {
  const response = await fetch(`/api/verifyBenefits/AAC`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      accept: '*/*'
    },
    body: JSON.stringify({
      utm_source: 'Recovery.com',
      pageURL: getPageURL(),
      ...form
    })
  })

  if (response && response.ok) {
    return true
  }
  return false
}
